import React, { PureComponent } from 'react';
import { Grid, GridColumn } from '@atlaskit/page';
import ComponentDetailHeader from '../components/ComponentDetailPage/ComponentDetailHeader';
import ComponentDetailBody from '../components/ComponentDetailPage/ComponentDetailBody';
import { BASE_URL } from '../config';
require('!style!css!less!../css/component-detail.less'); // eslint-disable-line
require('!style!css!less!../css/table.less'); // eslint-disable-line

export default class ComponentDetailPage extends PureComponent {
  state = {
    data: false,
    isLoadingData: true,
  };

  fetchData(componentName, componentVersion) {
    const componentTag = `${componentName}@${componentVersion}`;
    fetch(`${BASE_URL}/spa_data/${componentTag}.json`)
      .then(result => result.json())
      .then((data) => {
        this.setState({ data, isLoadingData: false });
      });
  }

  componentDidMount(newProps = {}) {
    const { params: { componentName, componentVersion }} = this.props;
    this.fetchData(componentName, componentVersion);
  }

  componentWillReceiveProps(nextProps) {
    const { params: { componentName, componentVersion }} = this.props;
    const { params: { componentName: newComponentName, componentVersion: newComponentVersion }} = nextProps;
    if (componentName !== newComponentName || componentVersion !== newComponentVersion) {
      this.setState({ isLoadingData: true });
      this.fetchData(newComponentName, newComponentVersion);
    }
  }

  render() {
    const { params: { componentName, componentVersion }} = this.props;
    const { data } = this.state;
    const { cssStats, jsStats } = data;
    let isInternal = false;

    if (data && data.pkgJsonInfo && (data.pkgJsonInfo.keywords.indexOf('internal') > -1)) {
      isInternal = true;
    }

    return (
      <Grid layout="fluid">
        <GridColumn>
          <ComponentDetailHeader
            componentName={componentName}
            isLoadingData={this.state.isLoadingData}
            defaultSelectedVersion={data.version}
            allVersions={data.allVersions}
            isInternal={isInternal}
          />
          <ComponentDetailBody
            componentName={componentName}
            componentVersion={componentVersion}
            data={data}
            cssStats={cssStats}
            jsStats={jsStats}
          />
        </GridColumn>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ComponentDetailPage.jsx